import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function Data({
  size = sizes.SMALL_MEDIUM,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="-2 0 14 14"
      {...props}
      style={{ width: size, height: size }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M10.9996 0H0.999634C0.723071 0 0.499634 0.223437 0.499634 0.5V13.5C0.499634 13.7766 0.723071 14 0.999634 14H10.9996C11.2762 14 11.4996 13.7766 11.4996 13.5V0.5C11.4996 0.223437 11.2762 0 10.9996 0ZM1.62463 1.125H10.3746V4.375H1.62463V1.125ZM10.3746 8.625H1.62463V5.375H10.3746V8.625ZM10.3746 12.875H1.62463V9.625H10.3746V12.875ZM2.74963 2.75C2.74963 2.91576 2.81548 3.07473 2.93269 3.19194C3.0499 3.30915 3.20887 3.375 3.37463 3.375C3.54039 3.375 3.69937 3.30915 3.81658 3.19194C3.93379 3.07473 3.99963 2.91576 3.99963 2.75C3.99963 2.58424 3.93379 2.42527 3.81658 2.30806C3.69937 2.19085 3.54039 2.125 3.37463 2.125C3.20887 2.125 3.0499 2.19085 2.93269 2.30806C2.81548 2.42527 2.74963 2.58424 2.74963 2.75ZM2.74963 7C2.74963 7.16576 2.81548 7.32473 2.93269 7.44194C3.0499 7.55915 3.20887 7.625 3.37463 7.625C3.54039 7.625 3.69937 7.55915 3.81658 7.44194C3.93379 7.32473 3.99963 7.16576 3.99963 7C3.99963 6.83424 3.93379 6.67527 3.81658 6.55806C3.69937 6.44085 3.54039 6.375 3.37463 6.375C3.20887 6.375 3.0499 6.44085 2.93269 6.55806C2.81548 6.67527 2.74963 6.83424 2.74963 7ZM2.74963 11.25C2.74963 11.4158 2.81548 11.5747 2.93269 11.6919C3.0499 11.8092 3.20887 11.875 3.37463 11.875C3.54039 11.875 3.69937 11.8092 3.81658 11.6919C3.93379 11.5747 3.99963 11.4158 3.99963 11.25C3.99963 11.0842 3.93379 10.9253 3.81658 10.8081C3.69937 10.6908 3.54039 10.625 3.37463 10.625C3.20887 10.625 3.0499 10.6908 2.93269 10.8081C2.81548 10.9253 2.74963 11.0842 2.74963 11.25Z"
        fill={colour}
      />
    </svg>
  )
}

Data.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
